<template>
  <div class="home page">
    <div class="page-wrap">
      <div class="home-hero hero">
        <HomeImage/>
        <div class="text right">
          <div class="inner">
            <img class="tta-gif" src="../assets/vid/tta.gif" alt="TouchTakeaway">
            <div class="ani-wrap">
              <h1 class="fadeInB">The Complete Online Platform for Your Takeaway</h1>
            </div>
            <div class="ani-wrap">
              <p
                class="fadeInB"
              >From mobile kitchens to restaurant chains, TouchTakeaway will bring your menu to the customer.</p>
            </div>
            <div class="ani-wrap">
              <p
                class="fadeInB"
              >TouchTakeaway is great for click and collect and order for delivery. It can be used for table or seat ordering in cafés, Restaurants, Bars, Stadiums, Theatres or any venue offering table service.</p>
            </div>
            <div class="ani-wrap">
              <p class="fadeInB">Discover how you could beneﬁt from TouchTakeaway.</p>
            </div>
            <div class="service">
              <div class="ani-wrap">
                <p class="fadeInB">0% SERVICE CHARGE</p>
              </div>
              <div class="ani-wrap">
                <p class="fadeInB">NO HIDDEN FEES</p>
              </div>
            </div>
            <div class="buttons">
              <router-link class="fadeInB" to="/how-to-order">
                <div class="default-btn" v-on:click="howToOrder">How To Order</div>
              </router-link>
              <router-link class="fadeInB" to="/examples">
                <div class="sec-btn" v-on:click="example">Examples</div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HomeImage from "@/components/HomeImage.vue";

export default {
  name: "homeImage",
  components: {
    HomeImage
  },
  methods: {
    example: function() {
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "example";
    },
    howToOrder: function() {
      var x = document.querySelector("#nav");
      x.className = "";
      x.classList += "how";
    }
  }
};
</script>

<style lang="scss" scoped>
.home.page {
  transition: 0.5s ease;
  color: #1c212e;
  .page-wrap {
    margin: auto;
    height: 100%;
    width: 100%;
    .home-hero {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      align-items: center;
      height: 100%;
      transition: 0.25s ease-out;
      .left,
      .right {
        @media (max-width: 1024px) {
          width: 100%;
          max-width: 100% !important;
        }
      }
      .home-image-wrap {
        width: 100%;
        max-width: 50%;
        @media (max-width: 1024px) {
          display: none;
        }
        @media (max-width: 450px) {
          display: none;
        }
      }
      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        text-align: left;
        color: inherit;
        padding: 100px;
        height: 100%;
        width: 100%;
        max-width: 50%;
        transform: translateX(0);
        transition: 0.25s ease-out;
        background-color: #fb6b05;
        color: #fff;
        @media (max-width: 1024px) {
          order: 1;
          padding: 100px 20px 40px 20px;
          height: auto;
          min-height:100vh;
        }
        .inner {
          max-width: 600px;
          margin: auto;
          .tta-gif {
            display: none;
            @media (max-width: 768px) {
              display: block;
              position: relative;
              top: 0;
              left: 0;
              max-width:100%;
              width:100%;
              margin:-100px 0;
            }
            @media (max-width:450px) {
              margin:-30px 0;
            }
          }
          .ani-wrap {
            width: 100%;
            overflow: hidden;
            h1 {
              color: #fff;
              margin: 0 0 20px 0;
              animation-delay: 0.5s;
            }
            p {
              margin: 0 0 10px 0;
              animation-delay: 0.75s;
            }
            a {
              animation-delay: 1.25s;
            }
          }
          .buttons {
            margin: 10px 0 0 0;
            a {
              animation-delay: 1.25s;
              margin: 0 10px 0 0;
              .sec-btn {
                border-color: #fff;
                color: #fff;
              }
            }
          }
          .service {
            width: 100%;
            margin: 10px 0 0 0;
            .ani-wrap {
              p {
                color: #fff;
                font-size: 26px;
                margin: 0 0 5px 0;
                animation-delay: 1s;
              }
            }
          }
        }
      }
    }
  }
}

.home.page.page-trans-enter-active {
  .page-wrap {
    .home-hero {
      .text {
        transform: translateX(100%);
      }
      .home-image-wrap {
        transform: translateX(-100%);
      }
    }
  }
}

.home.page.page-trans-leave-active {
  .page-wrap {
    .home-hero {
      opacity: 0;
    }
  }
}

.home.page.page-trans-leave-active {
  .fadeInB {
    animation: fadeOutB 0.25s ease-out both 1;
    animation-delay: 0s !important;
  }
}

.fadeInB {
  animation: fadeInB 0.25s ease-out both 1;
}

@keyframes fadeInB {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0%);
    opacity: 1;
  }
}

@keyframes fadeOutB {
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(20px);
    opacity: 0;
  }
}
</style>
